import React from 'react'
import Contact from '../contact/Contact'
export default function About() {
  return (
    <div>
<Contact/>
    </div>
  )
}
